export default {"src":"/_next/static/media/safe.7e8d186b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};